<template>
  <div id="page-card-app-settings">
    <m-row>
      <m-col lg="12" class="ml-4">

        <h4 class="mt-8">Utskicksmetod</h4>
        <p>Nedanstående kommunikationssätt bestämmer hur mottagaren får sitt födelsedagsmeddelande.</p>
        <memlist-checkbox 
          :text="$t('BIRTHDAYS_MODULE.SMS')"
          style="margin-top: 20px;"
          v-model="birthday_flags.sms"
        />

        <memlist-checkbox 
          :text="$t('BIRTHDAYS_MODULE.EMAIL')"
          style="margin-top: 20px;"
          v-model="birthday_flags.email"
        />

        <h4 class="mt-8">Val av SMS-meddelande</h4>
        <p>Välj uppsatt mall som kommer skickas ut på personens födelsedag via SMS till personens uppgivna mobilnummer.</p>
        
        <memlist-select-input2
          v-model="birthday_flags.sms_template_id"
          :items="template_options"
          :title="$t('SENDOUT_TEMPLATE.TEMPLATE_ID')"
          layout="vertical"
          size="sm"
          validation_type="TEXT"
        />

        <h4 class="mt-8">Val av E-post-meddelande</h4>
        <p>Välj uppsatt mall som kommer skickas ut på personens födelsedag via E-post till personens uppgivna E-postadress.</p>
        
        <memlist-select-input2
          v-model="birthday_flags.email_template_id"
          :items="template_options"
          :title="$t('SENDOUT_TEMPLATE.TEMPLATE_ID')"
          layout="vertical"
          size="sm"
          validation_type="TEXT"
        />

        <h4 class="mt-8">Utskickstid</h4>
        <p>Välj när på födelsedagen meddelandet skall skickas till personen.</p>
        
        <memlist-select-input2
          v-model="birthday_flags.sendout_time"
          :items="time_options"
          :title="$t('BIRTHDAYS_MODULE.TIME')"
          layout="vertical"
          size="sm"
          validation_type="TEXT"
        />

      </m-col>
    </m-row>
    

    <div class="mr-32">
      <RightSaveButton
        ref="save-button"
        :text="$t('COMMON.SAVE')"
        @click="save()"
        style="margin-right: 128px;"
        class="ml-4 mt-4 mx-right"
      />
    </div>
    
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';
import RightSaveButton from '@/view/components/buttons/RightSaveButton.vue';

export default {
  name: 'BirthdaysSettings',
  components: {
    RightSaveButton
  },
  computed: {
    time_options() {
      const options = [];

      for (let hour = 0; hour < 24; hour++) {
        const label = hour.toString().padStart(2, '0') + ':00';
        options.push({ value: label, text: label });
      }

      return options;
    },
    template_options() {
      return this.templates.map(item => ({ value: item.template_id, text: item.name }));
    },
    ...mapGetters(['isTHS', 'currentCompanyId','customer','sid'])
  },
  mixins: [ toasts ],
  data() {
    return {
      templates: [],
      birthday_flags: {},
    };
  },
  async mounted() {
    await this.fetch_settings();
    await this.fetch_template_options();
  },
  methods: {

    async fetch_template_options() {
      const res = await axios.get(`/template?company_id=${this.currentCompanyId}`);

      if (res.status === 200) {
        this.templates = res.data;
      }
    },


    async save() {
      const res = await axios.put(`/company/settings/system`, { birthday_flags: this.birthday_flags });

      if (res.status === 204) {
        this.toastr('success', this.$t('COMMON.OK'), this.$t('BIRTHDAYS_MODULE.UPDATED'));
      }
      else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('BIRTHDAYS_MODULE.UNABLE_UPDATE'));
      }

      this.$refs['save-button'].stop();
    },
    async fetch_settings() {
      const res = await axios.get(`/company/${this.sid}`);

      if (res.status === 200) {
        this.birthday_flags = res.data.company_settings.birthday_flags || {
          sms_template_id: null,
          email_template_id: null,
          sendout_time: '18:00',
          sms: false,
          email: false
        };
      }
    },
  }
};
</script>
